import { AfterViewInit, Component, ElementRef, HostListener, OnInit, TemplateRef, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { DropDownList } from '@syncfusion/ej2-dropdowns';
import { FileUploaderService } from './../../../services/file-uploader-service';
import { DemoService } from './../../../demo.service';

// Documenteditor Dependancies
import { ClickEventArgs } from '@syncfusion/ej2-navigations'
import {  DocumentEditorContainerComponent, ToolbarService, CustomToolbarItemModel,
   EditorService, SelectionService, SfdtExportService, TextExportService,
    WordExportService, PrintService, SectionFormatProperties} from '@syncfusion/ej2-angular-documenteditor';
import { HttpClient, HttpHeaders  } from '@angular/common/http';
import {Location} from '@angular/common';
// import { HotToastService } from '@ngneat/hot-toast';
import { ToolbarComponent } from '@syncfusion/ej2-angular-navigations';
import { SubjectTemplateDocs } from './../../../shared/models/subjectTemplateDocsModel.model';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { MysqlService } from './../../../services/mysql.service';

import { DialogUtility } from '@syncfusion/ej2-popups';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { DropDownListComponent } from '@syncfusion/ej2-angular-dropdowns';

// txc
import { fromEvent } from 'rxjs/internal/observable/fromEvent';
// import { saveDocument } from '../assets/js/textcontrol.js';
// import { saveDocument, loadDocument } from '../assets/js/custom.js';
declare const saveDocument: any;
declare const loadDocument: any;
declare const TXTextControl: any;
declare const saveTemplate: any;
import { Inject } from '@angular/core';
import { HotToastService } from '@ngneat/hot-toast';


declare const loadData: any;
declare const loadData2: any;
declare const loadDocument_TEMPLATE: any;
declare const loadDocument_TEMPLATE_Ext: any;

declare const MyTokem = 'Wexrf2EDhT9MxNwTgzaN';
// ... end txc
interface MergedDocument {
  document: string;
}


interface DocumentViewModel
{
    DocumentName: string;
    BinaryDocumet: String //btao
}

// sets a headers variable for propoer posts
const headers = new HttpHeaders()
  .set('content-type', 'application/json')
 // .set('Access-Control-Allow-Origin', '*');

@Component({
  selector: 'app-edit-docx-template-file',
  templateUrl: './edit-docx-template-file.component.html',
  styleUrls: ['./edit-docx-template-file.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [ToolbarService, EditorService, SelectionService, SfdtExportService,
     ToolbarComponent, TextExportService, WordExportService, PrintService]
})
export class EditDocxTemplateFileComponent implements OnInit, AfterViewInit {



 
  

// // set default page properties syncfusion
// defaultSectionFormat: SectionFormatProperties = {
//   headerDistance: 25,
//   footerDistance: 25,
//   // pageWidth: 1000,
//   // pageHeight: 700,
//   topMargin: 25.4,
//   bottomMargin: 25.4,
//   leftMargin: 28.6,
//   rightMargin: 25.4,
// };


 // DropDown
 tableData: any;
 doc_id: number;
 public template_data_fields: Object = { groupBy: 'icon', text: 'fileName', value: 'fileName' };

 // form model
 model: SubjectTemplateDocs;
 file_subject_number?;

// dialog
public DialogObj; // fordialog confirmation save





// DocumentEditor
@ViewChild('documenteditor_default') container: DocumentEditorContainerComponent;
// Create a custom tool bar item, and bar
public toolItem: CustomToolbarItemModel = {
prefixIcon: 'e-de-ctnr-lock',
tooltipText: 'Disable Image',
text: 'Disable Image',
id: 'Custom'
};
// tslint:disable-next-line:max-line-length
public items = [this.toolItem, 'Undo', 'Redo', 'Separator', 'Image', 'Table', 'Hyperlink', 'Bookmark', 'Comments', 'TableOfContents', 'Separator', 'Header', 'Footer', 'PageSetup', 'PageNumber', 'Break', 'Separator', 'Find', 'Separator', 'LocalClipboard', 'RestrictEditing'];
 selectedFileBlob: any;
 subject_template_doc: any;
 templateToLoad: any;
 templateDocxName: any;
 templateSFDTName: any;
 nav: any;
  baseUploadURL: string;
  baseUploadURLOriginalWordTemplates: string;
  baseUploadURLEmailTemplates: string;
  modalRef: BsModalRef;
  filename: string;




public onToolbarClick(args: ClickEventArgs): void {
switch (args.item.id) {
 case 'Custom':
     // Disable image toolbar item.
     this.container.toolbar.enableItems(4, false);
   //  this.container.documentEditor.open(this.selectedFileBlob);
     break;
}
};


 /// ..txc temps
 
 
//  @HostListener('document:txDocumentEditorLoaded', ['$event'])
//  onTxDocumentEditorLoaded() {
//    // wait until TXTextControl has been loaded
//    TXTextControl.addEventListener("textControlLoaded", function() {
//     this.LoadDocument_TEMPLATE('FakeID', this.doc_template_file)
//    });
//  }
 
 
 
 
 
accessToken: string = '12388-22132-12133';

//   onClickSave() {
//     saveDocument();
// }
  title?: any;
  username = "tsa-textControlvBeta";
  place = "pune";
  date = "29-06-1989";
  isUserNameFieldExist = false;
  editor = false;
f_subject_number = '1001.1.1.10';

job_plaintiff_name = "Nick Bowen";
subject_1_name = "Samy Newman";
job_document_number = '1.0.0.1';

  placeholders = ["username", "date", "place", "job_plaintiff_name", "subject_1_name", "job_document_number" ];
  formField: any;
  new_placeholder?: string | any;

  public _http: HttpClient;
  public _baseUrl: string;


  
  constructor(private http: HttpClient, public HttpClient: HttpClient,
    private _mysqlService: MysqlService, private route: ActivatedRoute, private router: Router,
    private fileUploader: FileUploaderService, private elem: ElementRef,
    private _demoService: DemoService,
    vcr: ViewContainerRef,
    private modalService: BsModalService,
    private _location: Location,
    public gfunc: GlobalFunctionsService,
    private toastr: HotToastService
  ) {


    // txc
    this._baseUrl = gfunc.azure_webRootPath; // API Root
    // this.toastr.setRootViewContainerRef(vcr);
    this.doc_id = +this.route.snapshot.paramMap.get('doc_id');




    this.baseUploadURL = this.gfunc.baseUploadURL; // all templates reside in the same directory.
    this.baseUploadURLOriginalWordTemplates = this.gfunc.baseUploadURLOriginalWordTemplates;
    this.baseUploadURLEmailTemplates = this.gfunc.baseUploadURLEmailTemplates; // all templates reside in the same directory.
    // this.model = new SubjectTemplateDocs(); only for create components

     // :: Load the Menus
     // Subject experiment on service drop down. to push array data
   //  this.buildSubjectVarMenu(2,5);
   //  this.buildAllJobVarsMenu();
   //  this.buildAllSubjectVarsMenu();


                          //      // get data source structure from Web API endpoint 'LoadData'
                          //      http.get<any>(this._baseUrl + 'textcontrol/loaddata2' + '?filename=' + 'NIX_FCFCOA_Fair_Work_Affidavit.docx').subscribe(result => {
                          // // http.get<any>(this._baseUrl + 'textcontrol/loaddata2' + '?filename=' + this.templateDocxName).subscribe(result => {

                          //   // call JavaScript function from injected 'textcontrol.js'
                          //   loadData2(result);

                          // }, error => console.error(error));
  }
  // Function runs
  async onClickMergeDocument() {

    // get the saved document from TXTextControl
    const postDocument: MergedDocument = {
      document: await saveDocument(),
    };

    // post the document to endpoint 'MergeDocument' // Saves the file as the same name. // see if works. may not was the file may be open in the stream
    this.http.post<MergedDocument>(this._baseUrl + 'textcontrol/mergedocument' + '?DocumentName=' + this.templateDocxName, postDocument).subscribe(result => {
      // this.http.post<MergedDocument>('http://20.70.181.64:80/' + 'textcontrol/mergedocument' + '?DocumentName=' + this.templateDocxName, postDocument).subscribe(result => {
    

      // this.http.post<MergedDocument>(this._baseUrl + 'textcontrol/mergedocument', postDocument).subscribe(result => {
      // load the results into TXTextControl
      
   

// This function is very important and now pauses then load the document correctly.
setTimeout(() => {  
  console.log("A Simple Pause!"); 
  console.log("Now Ready to load...");
  loadDocument(result.document);
}, 4000);


     // this.sendWordTemplateViaFTP(this.templateDocxName); // moves file over ready for merge in PHP
     this.toastr.success('Succesfully Loaded Base Merge Tempale!', {icon: '👏',})

     // see if we can automate sending the - sends a filename to get the file and place back home in /WordTemplates
     this.sendWordTemplateViaFTP([], this.templateDocxName);


    }, error => console.error(error));

  }

  showToast() {
    this.toastr.show('Your New Template Document Editor: September 2022', {icon: '👏😎',})
  }

  ngOnInit() {

        // load the doc information form
        this.getSubjectTemplateDoc(this.doc_id);

 //  this.refresh_txc() // this unload the txc from the dom so that can be loaded again through the route change. !mportant. 
  
    // // load the doc information form
    // this.getSubjectTemplateDoc(this.doc_id);
    // load drop down - server document list
 //    this.loadList(this.doc_id);
     // load the default docx template into Document editor.
     // this.LoadServerFileViaAPI(this.templateToLoad);




   }
 
 
   ngAfterViewInit(){
   // this.LoadDocument_TEMPLATE('FakeID', this.templateDocxName)

  }




public sendWordTemplateViaFTP(model, filename){
  // send filename to get from tsaVM and place in PHP_APP/WordTemplates
  this._mysqlService.sendWordTemplateViaFTP(model, filename).subscribe(
    (data) => {
      // this.trace_candidate_update = data;
      // this.toastr.success('Sent Email.');
      const res = data;
      console.log(res); // not working as response is showing in body
      // console.log(res._body);
      // console.log(res.text()); // Convert response to a string
      // now close the modal
      // this.closeParentModel.emit();
      // this.closeParentModel3.emit();
      // // refresh the invoice page if
      // if ( model.invoice_id > 0 ){
      //   this.refreshSujectInvoicePage.emit(this.subject_id);
      // }
    },
    (error) => {
      // this.toastr.error('Error sending Email');
     return console.log(error);
    }
  );
  // once moved it is the ready for processing.
    // once moved it is the ready for processing.
    this.toastr.success('File get via ftp from tsaVM -> APP_PHP.');
}



public sendWordTemplateViaFTP_Out(model, filename){
  // send filename to get from tsaVM and place in PHP_APP/WordTemplates
  this._mysqlService.sendWordTemplateViaFTP_Out(model, filename).subscribe(
    (data) => {
      // this.trace_candidate_update = data;
      // this.toastr.success('Sent Email.');
      const res = data;
      console.log(res); // not working as response is showing in body
      // console.log(res._body);
      // console.log(res.text()); // Convert response to a string
      // now close the modal
      // this.closeParentModel.emit();
      // this.closeParentModel3.emit();
      // // refresh the invoice page if
      // if ( model.invoice_id > 0 ){
      //   this.refreshSujectInvoicePage.emit(this.subject_id);
      // }
    },
    (error) => {
      // this.toastr.error('Error sending Email');
     return console.log(error);
    }
  );
  // once moved it is the ready for processing.
    // once moved it is the ready for processing.
    this.toastr.success('File put via ftp PHP_APP -> tsaVM.');
}



public saveBothTemplate(filename, model) :void {
  // pop up notification

 // console.log('Original Template Name: ' + this.templateDocxName);
// console.log('newTemplateFilname: ' + model.newTemplateFileName);

  // save the docx
  this.saveDocx(filename);
  // save the sfdt
  this.saveSfdt(filename);
  // update database fields ()
  this.editDoc(model);
  // return back to template view
  // this.toastr.info('We are done, template saved.');
  // this.DialogObj.hide();
}

public saveAsBothTemplate(filename, model) :void {
  // pop up notification

 // console.log('Original Template Name: ' + this.templateDocxName);
 

console.log('newTemplateFilname: ' + model.newTemplateFileName);
// if (model.newTemplateFileName !== '') {
// console.log('newTemplateFilename - is empty');
// }else{
//   // change the name and save as.
    // change the filename, save versions and update communication doc data records.
  filename = model.newTemplateFileName + '.docx';
  // this.toastr.custom('New Filename', 'Save as' + filename);
  // set the new file values for the database update.
  model.doc_template_file = filename;
  model.sfdt_template_file = model.newTemplateFileName + '.sfdt';
// }

// console.log('New Name: ' + model.newTemplateFileName);
// // sets a new filename from model.newTemplateFilename form field
// if (model.newTemplateFileName !== 'undefined' ||
//  model.newTemplateFileName !== '') { // sees if there is any chars in the string.
//   // change the filename, save versions and update communication doc data records.
//   this.toastr.custom('New Filename','Save As Seleced');
//   filename = model.newTemplateFileName + '.docx';
//   // set the new file values for the database update.
//   model.doc_template_file = filename;
//   model.sfdt_template_file = model.newTemplateFileName + '.sfdt';
// } else {
//   // do as normal.
//   // model.doc_template_file = filename;
// }



  // save the docx
  this.saveDocx(filename);
  // save the sfdt
  this.saveSfdt(filename);
  // update database fields ()
  this.editDoc(model);
  // return back to template view
  // this.toastr.info('We are done, template saved as.');
  // this.DialogObj.hide();

  //hide the modal if open.
  this.modalRef.hide();
}


public saveDocx(filename) :void {
  this.container.documentEditor.serialize(); // !!!! THIS WORKED!!!
  this.container.documentEditor.saveAsBlob('Docx').then((exportedDocument: Blob) => {
   // The blob can be processed further
  // let current_documennt = exportedDocument;
   let formData = new FormData();
   let file = exportedDocument; // need to establish
   formData.append('selectFile', file, filename);
   this.fileUploader.uploadDocxTemplateFiles(formData, 1).subscribe(
     //res=> this.dataLoaded(res)
     res => {
       let data = res;
       console.log('File Saved: ' + filename);
      //  this.toastr.success('Template Saved: ' + filename);
       // TODO: issue a notification upon save + error
     }
   );

 });
}


public printDoc(){
  TXTextControl.printDocument()
}



public saveSfdt(filename) :void {

// if the file has a docx extension - remove and add /9,sfdt)
let sent_file_ext = filename.slice(-5); // gets last 5 chars
let sent_file_no_ext = filename.replace(/\.[^/.]+$/, ''); // removes etension

this.container.documentEditor.serialize(); // !!!! THIS WORKED!!!
this.container.documentEditor.saveAsBlob('Sfdt').then((exportedDocument: Blob) => {
 // The blob can be processed further
// let current_documennt = exportedDocument;
 let formData = new FormData();
 
  let file = exportedDocument; // need to establish
 let new_filename = sent_file_no_ext + '.sfdt';

 formData.append('selectFile', file, new_filename);
 this.fileUploader.uploadDocxTemplateFiles(formData, 1).subscribe(
   //res=> this.dataLoaded(res)
   res => {
     let data = res;
     console.log('File Saved: ' + new_filename);
    //  this.toastr.success('Template Saved: ' + new_filename);
     // TODO: issue a notification upon save + error
   }
 );

});
}


// downloads sfdt to harddrive
public saveAsSfdt(): void {
  this.container.documentEditor.save(this.templateSFDTName, 'Sfdt');
}
// downloads docx to hardrive
public saveAsDocx(): void {
  this.container.documentEditor.save(this.templateDocxName, 'Docx');
}


public onFileChange(e: any): void {
  if (e.target.files[0]) {
    let file = e.target.files[0];
    if (file.name.substr(file.name.lastIndexOf('.')) !== '.sfdt') {
      this.loadFile(file);
    }
  }
}

public loadFile(file: File): void {
  let ajax: XMLHttpRequest = new XMLHttpRequest();
  ajax.open('POST', this.gfunc.sopDocxServerURL, true);
  ajax.onreadystatechange = () => {
    if (ajax.readyState === 4) {
      if (ajax.status === 200 || ajax.status === 304) {
        // open SFDT text in document editor
        this.container.documentEditor.open(ajax.responseText);
      }
    }
  }
  let formData: FormData = new FormData();
  formData.append('files', file);
  ajax.send(formData);
}

// end harddrive functions


// Print Document
public onPrint() :void {
  this.container.documentEditor.print();
}






// for save file

getSubjectTemplateDoc(doc_id) {
this._demoService.getSubjectTemplateDoc(doc_id).subscribe(
  data => {
    this.subject_template_doc = data;
    const res = data[0];

    this.templateToLoad = res.doc_template_file;
    this.templateDocxName = res.doc_template_file;
    this.templateSFDTName = res.sfdt_template_file;
    //  this.onCreate();

    this.file_subject_number = res.file_subject_number;


// Attempt now to load the data for the txc -- moved here to get the name
            // get data source structure from Web API endpoint 'LoadData'
            this.http.get<any>(this._baseUrl + 'textcontrol/loaddata2' + '?filename=' + this.templateDocxName).subscribe(result => {
              // http.get<any>(this._baseUrl + 'textcontrol/loaddata2' + '?filename=' + this.templateDocxName).subscribe(result => {

                // call JavaScript function from injected 'textcontrol.js'
                loadData2(result);

              }, error => console.error(error));



              // see if I can preload the template file now.... ( THIS WORKS IN THIS METHOD........)

// This function is very important and now pauses then load the document correctly.
setTimeout(() => {  
  console.log("A Simple Pause!"); 
  console.log("Now Ready to load...");
  this.LoadDocument_TEMPLATE('FakeID', this.templateDocxName);
}, 4000);



            //   this.toastr.success(
            //     // 'Please Click Load Template, or uploade a starting point. - To Start Editing and adding merge fields to your template.',
            //     `Please load or upload a <i>Document Template</i>! We have preloaded the template: <u class="bg-toast-100">${this.templateDocxName}</u>.`,
            //     {
            //     icon: '👏😎',
            //     autoClose: false,
            //     dismissible: true,
            //     position: 'top-center',
            //  //   theme: 'snackbar',
            //     role: 'alert',
            //     ariaLive: 'assertive',
            //     style: {
            //       border: '10px solid #713200',
            //       padding: '16px',
            //      // color: '#713200',
            
            //     },
            //     // iconTheme: {
            //     //   primary: '#713200',
            //     //   secondary: '#FFFAEE',
            //     // },
            //   });





    // this.getBrandBrandType(res.brand_type_id);
    // this.getSubjectComType(res.subject_com_type_id);
    // this.getJobTypeLocation(res.job_type_location_id);
    // this.getJobTypeDocument(res.job_type_document_type_id);
    // this.getJobTypeCourt(res.job_type_court_id);
    // this.getJobTypeAffidavit(res.job_type_affidavit_type_id);
    // this.getJobType(res.job_type_id);


    // load the drop downs
    // this.getJobTypeLocations(res.job_type_id);
    // this.getJobTypeCourts(res.job_type_court_id);
    // this.getJobTypeDocumentTypes(res.job_type_court_id);
    // this.getJobTypeAffidavitTypes(res.job_type_document_type_id);
    // this.getJobTypes();
  },
  err => console.error(err),
  () => {console.log('loaded');
  // load template file.
  // this.LoadServerFileViaAPI(this.templateDocxName);
// this.Load_TemplateFile(this.templateDocxName);

}
);
}




editDoc(model) {
  // model.job_id = this.job_id;
   this._demoService.updateSubjectTemplateDoc(model).subscribe(

    data => { // this.trace_candidate_update = data;
      // refresh the list
     // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
    // this.toastr.success('Document Database Updated');
  //  this.createJobSubjectsMultiple(model);
    // Subject to reload the manager component parent.
   // TraceCandidateManagerComponent.returned.next(false);
  // this.router.navigate(['/admin/jobs/create-job-3/' + model.job_id + '']);
  // this.router.navigate(['/admin/jobs/view/' + model.job_id + '']);

              return true;
    },
    // error => {
    //  // console.error('Error saving Event!');
    //   this.toastr.error('Error saving Document!');
    //   return Observable.throw(error);
    // },
    err => console.error(err),
    () => {
      console.log('done updates'); 
    //  this.router.navigate(['/admin/communication/com_type_template_doc_view/' + this.doc_id + '']);
  }
);
  }




// Dialog Pop Ups Confirmations

// public onOpenDialog = function(event: any): void {
//   DialogUtility.confirm('Do you wish to overide current template file with your chamges!');
// };


// custom dialog

public onOpenDialog = function(event: any, filename, model): void {
    this.DialogObj = DialogUtility.confirm({
    title: 'Save Template Docx File',
    content: 'Save this file, {{filename}} -  and update the {{model.doc_name}} database records!',
    okButton: {  text: 'OK', click: this.okClick.bind(this) },
    cancelButton: {  text: 'Cancel', click: this.cancelClick.bind(this) },
    showCloseIcon: true,
    closeOnEscape: true,
    animationSettings: { effect: 'Zoom' }
});
}
private okClick(filename, model): void {
//  alert('you clicked OK button');
  // run save file option
  this.saveBothTemplate(filename, model);
}

private cancelClick(): void {
  // alert('you clicked Cancel button');
  this.DialogObj.hide();
};


// to router navigate back
public goBack() {
  this._location.back();
  }


// MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  this.modalRef = this.modalService.show(template);
}

// :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');
  this.modalRef.hide();
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
};


docEditTemplateFile(doc_id) {
  this.router.navigate(['/admin/communication/template_doc_view/template/' + doc_id + '']);
}

docViewTemplateFile(doc_id) {
  this.router.navigate(['/admin/communication/template_doc_view/template-view/' + doc_id + '']);
}

refreshPage(doc_id){
// unload from dom txc editor so it can load again on refresh
this.refresh_txc(); 
  this.router.navigate(['/admin/communication/com_type_template_doc_view/' + doc_id + ''], { skipLocationChange: true })
      .then(() => this.router.navigate(['/admin/communication/template_doc_view/template/' + doc_id + ''])
      );
};





// ...txc



// txc




openDocument(e: any) {


  // console.log('Output of form event' + JSON.stringify(e));
  
  
    this.readDocument(e);
    TXTextControl.enableCommands();
  
    TXTextControl.addEventListener("textFieldEntered", function(e: any) {
      // TXTextControl.sendCommand(
      //   TXTextControl.Command.EditMode,
      //   TXTextControl.EditMode.Edit
      // );
    });
  
    TXTextControl.addEventListener("textFieldLeft", function(e: any) {
      // TXTextControl.sendCommand(
      //   TXTextControl.Command.EditMode,
      //   TXTextControl.EditMode.ReadAndSelect
      // );
    });
  }
  
  
  
  
  
  
  
  
  // :: Loads a file directory from the server ()
  public loadServerFileDirectTxc(filename) {
  
  if (filename == undefined){filename = 'QCATSubServOccupant.docx'}; // set something
  this.http.get(this.gfunc.baseUploadURL_SSL + '/' + filename, { responseType: 'blob' }).subscribe(data => {
  //  console.log('data2 on import...', data);
    this.selectedFileBlob = data;
    // var encoded = btoa(data); // btoa base-64-encodes strings.
    TXTextControl.loadDocument(TXTextControl.streamType.WordprocessingML, data);
  
    // let sfdt: string = data;
    // this.container.documentEditor.open(sfdt);
    // this.container.documentEditor.open(this.selectedFileBlob);
    // this.toastr.success('Template Loaded in Editor - Directly');
   // this.model.newTemplateFileName = this.selectedFileData;
    //
  });
  
  
  };
  
  
  // :: Loads a file directory from the server ()
  public loadServerFileDirectTxc_LOCAL(filename) {
  filename = 'ACTMagistratesCourtAffidavit_Order_MagistratesCourt.docx'
  if (filename == undefined){filename = 'QCATSubServOccupant.docx'}; // set something
  this.http.get('https://tsa.backvault.com.au//APP_PHP/assets/docs/1126.2.1.1/allVarsTest-CookaroundtheWorld-1126.2.1.1-260822-110114.docx', { responseType: 'blob' }).subscribe(data => {
  //  console.log('data2 on import...', data);
    this.selectedFileBlob = data;
    // var encoded = btoa(data); // btoa base-64-encodes strings.
    TXTextControl.loadDocument(TXTextControl.streamType.WordprocessingML, data);
  
    // let sfdt: string = data;
    // this.container.documentEditor.open(sfdt);
    // this.container.documentEditor.open(this.selectedFileBlob);
    // this.toastr.success('Template Loaded in Editor - Directly');
   // this.model.newTemplateFileName = this.selectedFileData;
    //
  });
  
  
  };
  
  
  
  
  
  
  loadTxcDocument(doc_id) {
    // this.router.navigate([
    //   '/admin/communication/com_type_template_doc_view/' + doc_id + '',
    // ]);
  var FileToload = "https://tsa.backvault.com.au/APP_PHP/assets/docs/1126.2.1.1/allVarsTest-CookaroundtheWorld-1126.2.1.1-260822-110114.docx" as string;
  var encoded = btoa(FileToload); // btoa base-64-encodes strings.
  TXTextControl.loadDocument('MSWord', FileToload);
  TXTextControl.sendCommand(
  TXTextControl.Command.EditMode,
  // TXTextControl.EditMode.ReadAndSelect
  TXTextControl.EditMode.Edit
  );
  
  }
  
  // goal is to create a direct link first and and load a file from the server diretly - simples
  // then code the rest in with the drop downs - to load the file after the drop downs selected
  // then work out how to save the file back to the server, after edit, - like create document function, except it just saves the file to the location and
  // .. the rest of the normal commnmands
  
  // bata bing bata boom... and the prototype is done and working
  
  // - Setup all Vars to be accessible in model, and merge
  // work out if empty errors - that is if a variable does not exists on the page... creates js errors.
  // - loop and merges and headers
  // - themes and backgrounds and do we need them any more.
  // then setup a a system to create / edit the templates / themes / merges
  
  
  readDocument(input: any) {
    if (input.target.files && input.target.files[0]) {
      var fileReader = new FileReader();
      fileReader.onload = (e: any) => {
        var streamType = TXTextControl.streamType.PlainText;
  
        // set the StreamType based on the lower case extension
        switch (
          input.target.value
            .split(".")
            .pop()
            .toLowerCase()
        ) {
          case "doc":
            streamType = TXTextControl.streamType.MSWord;
            break;
          case "docx":
            streamType = TXTextControl.streamType.WordprocessingML;
            break;
          case "rtf":
            streamType = TXTextControl.streamType.RichTextFormat;
            break;
          case "htm":
            streamType = TXTextControl.streamType.HTMLFormat;
            break;
          case "tx":
            streamType = TXTextControl.streamType.InternalUnicodeFormat;
            break;
          case "pdf":
            streamType = TXTextControl.streamType.AdobePDF;
            break;
        }
  
        // load the document beginning at the Base64 data (split at comma)
        TXTextControl.loadDocument(streamType, e.target.result.split(",")[1]);
         TXTextControl.sendCommand(
          TXTextControl.Command.EditMode,
          // TXTextControl.EditMode.ReadAndSelect
          TXTextControl.EditMode.Edit
        );
  
      };
  
      // read the file and convert it to Base64
      console.log('ReadAsDataURL: ' + input.target.files[0]);
      fileReader.readAsDataURL(input.target.files[0]);
    }
  }
  
  
  // this is how I can run over my template variables live.... ( just setup my new biding code and we can see it run live.... and then simply edit and save all in one step!!!!!!)
  async setInputs(item: any, placeholder:any) {
    await new Promise(resolve => {
      item.find(`{{${placeholder}}}`, 0, 0, (r: any) => {
            console.log(r);
            TXTextControl.selection.setText("");
            TXTextControl.selection.setStart(r, () => {
            TXTextControl.formFields.addTextFormField(1000, (f: { setText: (arg0: any[]) => void; setName: (arg0: any) => void; }) => {
                this.isUserNameFieldExist = true;
                f.setText(this[placeholder]);
                f.setName(placeholder);
                resolve(placeholder);
            });
            });
          });
    })
  
  }
  
  async setViewerInputs(item: any, placeholder: any) {
    await new Promise(resolve => {
      item.find(`{{${placeholder}}}`, 0, 0, (r: any) => {
            TXTextControl.selection.setText(this[item]);
            resolve("done")
          });
    })
  
  }
  
  
  mailMerge(){
    // TXTextControl.Load("template.tx", TXTextControl.StreamType.InternalUnicodeFormat);
    // const data = System.IO.File.ReadAllText("data.json");
  
    // using (TXTextControl.DocumentServer.MailMerge mailMerge =
    //        new TXTextControl.DocumentServer.MailMerge())
    // {
    //     mailMerge.TextComponent = textControl1;
    //     mailMerge.MergeJsonData(data);
    // }
  
  
  
  
  
  
  
  
  
  
  }
  
  
  bindViewer() {
    TXTextControl.textParts.forEach( async(item: any, i: any) => {
     if (item.find && i === 0) {
       for (let i=0; i<this.placeholders.length; i++) {
         await  this.setViewerInputs(item, this.placeholders[i]);
       }
     }
   });
  }
  
  bind() {
  
   TXTextControl.textParts.forEach( async(item: any, i: any) => {
     if (item.find && i === 0) {
       for (let i=0; i<this.placeholders.length; i++) {
         await  this.setInputs(item, this.placeholders[i]);
       }
  
       this.editor = true;
     }
   });
  
   // TXTextControl.getSubTextParts(function(r) {
   //   console.log(r)
   // })
  
   // TXTextControl.getTextParts(function(r) {
   //   console.log(r)
   // })
  
   // TXTextControl.getText(function(r) {
   //   console.log(r)
   // })
  }
  
  
  
  
  
  // TSA
  
  bindTsaVars() {
  TXTextControl.textParts.forEach( async(item: any, i: any) => {
    if (item.find && i === 0) {
      for (let i=0; i<this.placeholders.length; i++) {
        await  this.setInputsTsaVars(item, this.placeholders[i]);
      }
  
      this.editor = true;
    }
  });
  
  // TXTextControl.getSubTextParts(function(r) {
  //   console.log(r)
  // })
  
  // TXTextControl.getTextParts(function(r) {
  //   console.log(r)
  // })
  
  // TXTextControl.getText(function(r) {
  //   console.log(r)
  // })
  }
  
  
  // :: WORKING VARS REPLACEMENT WORKING --
  // this is how I can run over my template variables live.... ( just setup my new biding code and we can see it run live.... and then simply edit and save all in one step!!!!!!)
  async setInputsTsaVars(item: any, placeholder:any) {
  await new Promise(resolve => {
    item.find( '$' + `{${placeholder}}`, 0, 0, (r: any) => {
          console.log(r);
          TXTextControl.selection.setText("");
          TXTextControl.selection.setStart(r, () => {
          TXTextControl.formFields.addTextFormField(1000, (f: { setText: (arg0: any[]) => void; setName: (arg0: any) => void; }) => {
              this.isUserNameFieldExist = true;
              f.setText(this[placeholder]);
              f.setName(placeholder);
              resolve(placeholder);
          });
          });
        });
  })
  
  }
  
  // BKUP working version below.
  
      // // this is how I can run over my template variables live.... ( just setup my new biding code and we can see it run live.... and then simply edit and save all in one step!!!!!!)
      // async setInputsTsaVars(item: any, placeholder:any) {
      //   await new Promise(resolve => {
      //     item.find( `{{${placeholder}}}`, 0, 0, (r: any) => {
      //           console.log(r);
      //           TXTextControl.selection.setText("");
      //           TXTextControl.selection.setStart(r, () => {
      //           TXTextControl.formFields.addTextFormField(1000, (f: { setText: (arg0: any[]) => void; setName: (arg0: any) => void; }) => {
      //               this.isUserNameFieldExist = true;
      //               f.setText(this[placeholder]);
      //               f.setName(placeholder);
      //               resolve(placeholder);
      //           });
      //           });
      //         });
      //   })
  
      // }
  
  
  
  onClickSave2(prop: any) {
  const source = fromEvent(TXTextControl, "textFieldChanged");
  source.subscribe((f: any) => {
    // if(f.textField.name === 'username') {
    //   this.username = f.textField.text;
    // }
  
    console.log("changes");
  });
  
  if (!this.isUserNameFieldExist) {
    TXTextControl.formFields.addTextFormField(1000, (f: { setText: (arg0: any) => void; setName: (arg0: any) => void; }) => {
      this.isUserNameFieldExist = true;
      f.setText(prop);
      f.setName(prop);
    });
  } else {
    TXTextControl.formFields.forEach((formField: { getName: (arg0: (formFieldName: any) => void) => void; setText: (arg0: any) => void; }) => {
      formField.getName((formFieldName: any) => {
        if (formFieldName === prop) {
          formField.setText(prop);
        }
      });
    });
  }
  }
  
  
  
  // I need three apps built custom to make this work. // this should be in a js file!
  saveDocument_Base() {
  TXTextControl.saveDocument(TXTextControl.StreamType.HTMLFormat,
      function (e:any) {
          console.log('FileName: ' + this.templateDocxName + e.data);
         
          console.log('This is saving........ This is where the Node. Js');
          alert('now need to build a node js app to do the websocket to talk to the API backend TCP service.')

          //  this now needs to do a get request to save the document. (get request with document and filename.)
      
          saveTemplate(e.data);

      });
  }
  
  
  
  saveDocumentAsAdobePDF(){
  
      // save the document as PDF
      TXTextControl.saveDocument(TXTextControl.StreamType.AdobePDF, function (e:any) {
        let bDocument = e.data;
        // create temporary link to download document
        var element = document.createElement('a');
        element.setAttribute('href', 'data:application/octet-stream;base64,' + bDocument);
        element.setAttribute('download', "results.pdf");
  
        element.style.display = 'none';
        document.body.appendChild(element);
  
        // simulate click
        element.click();
  
        // remove the link
        document.body.removeChild(element);
        });
  
  }
  
  
  saveDocumentAsWordprocessingML(){
  
  // save the document as PDF
  TXTextControl.saveDocument(TXTextControl.StreamType.WordprocessingML, function (e:any) {
    let bDocument = e.data;
    // create temporary link to download document
    var element = document.createElement('a');
    element.setAttribute('href', 'data:application/octet-stream;base64,' + bDocument);
    element.setAttribute('download', "results.docx");
  
    element.style.display = 'none';
    document.body.appendChild(element);
  
    // simulate click
    element.click();
  
    // remove the link
    document.body.removeChild(element);
    });
  
  }
  
  
  saveDocumentAsMSWord(){
  
  // save the document as PDF
  TXTextControl.saveDocument(TXTextControl.StreamType.MSWord, function (e:any) {
    let bDocument = e.data;
    // create temporary link to download document
    var element = document.createElement('a');
    element.setAttribute('href', 'data:application/octet-stream;base64,' + bDocument);
    element.setAttribute('download', "results.doc");
  
    element.style.display = 'none';
    document.body.appendChild(element);
  
    // simulate click
    element.click();
  
    // remove the link
    document.body.removeChild(element);
    });
  
  }
  
  
  
  saveDocumentAsHTMLFormat(){
  
  // save the document as PDF
  TXTextControl.saveDocument(TXTextControl.StreamType.HTMLFormat, function (e:any) {
    let bDocument = e.data;
    // create temporary link to download document
    var element = document.createElement('a');
    element.setAttribute('href', 'data:application/octet-stream;base64,' + bDocument);
    element.setAttribute('download', "results.html");
  
    element.style.display = 'none';
    document.body.appendChild(element);
  
    // simulate click
    element.click();
  
    // remove the link
    document.body.removeChild(element);
    });
  
  }
  
  
  
  saveDocumentAsSpreadsheetMLt(){
  
  // save the document as PDF
  TXTextControl.saveDocument(TXTextControl.StreamType.SpreadsheetML, function (e:any) {
    let bDocument = e.data;
    // create temporary link to download document
    var element = document.createElement('a');
    element.setAttribute('href', 'data:application/octet-stream;base64,' + bDocument);
    element.setAttribute('download', "results.xml");
  
    element.style.display = 'none';
    document.body.appendChild(element);
  
    // simulate click
    element.click();
  
    // remove the link
    document.body.removeChild(element);
    });
  
  }
  
  
  
  saveDocumentAsRichTextFormat(){
  
  // save the document as PDF
  TXTextControl.saveDocument(TXTextControl.StreamType.RichTextFormat, function (e:any) {
    let bDocument = e.data;
    // create temporary link to download document
    var element = document.createElement('a');
    element.setAttribute('href', 'data:application/octet-stream;base64,' + bDocument);
    element.setAttribute('download', "2results.rtf");
  
    element.style.display = 'none';
    document.body.appendChild(element);
  
    // simulate click
    element.click();
  
    // remove the link
    document.body.removeChild(element);
    });
  
  }
  
  
  saveDocumentAsPlainText(){
  
  // save the document as PDF
  TXTextControl.saveDocument(TXTextControl.StreamType.PlainText, function (e:any) {
    let bDocument = e.data;
    // create temporary link to download document
    var element = document.createElement('a');
    element.setAttribute('href', 'data:application/octet-stream;base64,' + bDocument);
    element.setAttribute('download', "results.txt");
  
    element.style.display = 'none';
    document.body.appendChild(element);
  
    // simulate click
    element.click();
  
    // remove the link
    document.body.removeChild(element);
    });
  
  }
  
  
  
  saveDocumentAsInternalUnicodeFormat(){
  
  // save the document as PDF
  TXTextControl.saveDocument(TXTextControl.StreamType.InternalUnicodeFormat, function (e:any) {
    let bDocument = e.data;
    // create temporary link to download document
    var element = document.createElement('a');
    element.setAttribute('href', 'data:application/octet-stream;base64,' + bDocument);
    element.setAttribute('download', "results.xlxs");
  
    element.style.display = 'none';
    document.body.appendChild(element);
  
    // simulate click
    element.click();
  
    // remove the link
    document.body.removeChild(element);
    });
  
  }
  
  
  // need api to - does note work with current setuo may with server tiw ill
  
  async onClickLoadDocument() {
  // get a document from the Web API endpoint 'LoadDocument'
  this.HttpClient.get<any>(this._baseUrl + 'api/viewer/loaddocument').subscribe(result => {
    loadDocument(result);
  }, error => console.error(error));
  }
  
  
  
   //customs.js
  onClickSave() {
    saveDocument();
  }
  
            // onClickLoad() {
            //   // loadDocument();
            //   // TXTextControl.loadDocument(TXTextControl.StreamType.HTMLFormat,
            //   //   btoa('<strong>Test</strong>'));
            // // let mystring ='dasfd'; 
            // //   // TXTextControl.loadDocument(TXTextControl.StreamType.WordprocessingML,
            // //   //   btoa(mystring));
  
            //     // TXTextControl.loadDocument(TXTextControl.StreamType.WordprocessingML,
            //     // 'https://tsa.backvault.com.au/APP_PHP/assets/docs/1126.2.1.1/allVarsTest-CookaroundtheWorld-1126.2.1.1-260822-110114.docx');
            //     let filename = 'allVarsTest-CookaroundtheWorld-1126.2.1.1-260822-110114.docx';
            //     let formData_api: FormData = new FormData();
            //     const URL_server_file = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + this.file_subject_number + '/';
            //     // this.http.get(URL_server_file + filename, { responseType: 'blob' }).subscribe(data => {
            //       // this.http.get(this.gfunc.baseUploadURL_SSL + '/TestCreateAndSaveFile.docx', { responseType: 'blob' }).subscribe(data => {
            //         this.http.get(this.gfunc.baseUploadURL_SSL + '/sample.docx', { responseType: 'text' }).subscribe(data => {
            //       // console.log('data2 on import...', data);
            //        this.selectedFileBlob = data;
              
            //        // moved inside this subscrition
            //        formData_api.append('files', data);
            //       //  this.readDocument(selectedFileBlob);
  
            //       // file reader and new file reader goes herers.
            //       // fileReader.readAsDataURL(input.target.files[0]);
            //           // let assinged_data = data as string;
  
            //           var str = this.selectedFileBlob;
            //           var b64 = window.btoa(unescape(encodeURIComponent(str)))
            //           console.log(b64);
                      
            //           var str2 = decodeURIComponent(escape(window.atob(b64)));
            //           console.log(str2);
  
            //           var str3 =  btoa(this.selectedFileBlob)
  
            //       // load the document beginning at the Base64 data (split at comma)
            //       // TXTextControl.loadDocument(TXTextControl.streamType.WordprocessingML,  btoa(str2));
            //       TXTextControl.loadDocument(TXTextControl.streamType.PlainText,  btoa(data));
            //   //  TXTextControl.loadDocument(TXTextControl.streamType.PlainText,  btoa(this.gfunc.baseUploadURL_SSL + '/sample.txt'));
  
            //   //  TXTextControl.loadDocument(TXTextControl.streamType.WordprocessingML, btoa(str3));
                  
            //        TXTextControl.sendCommand(
            //         TXTextControl.Command.EditMode,
            //         // TXTextControl.EditMode.ReadAndSelect
            //         TXTextControl.EditMode.Edit
            //       );
  
  
            //       formData_api.append('files', this.selectedFileBlob);
            //       //  ajax.send(formData_api);
            //   // TXTextControl.loadDocument(TXTextControl.StreamType.WordprocessingML,
            //   //   btoa(this.selectedFileBlob));
            //       console.log('FormData: ' + this.selectedFileBlob)
            //     });
            //  }
  
  
                  onClickLoad_TXT() {
                    // loadDocument();
                    // TXTextControl.loadDocument(TXTextControl.StreamType.HTMLFormat,
                    //   btoa('<strong>Test</strong>'));
                  // let mystring ='dasfd'; 
                  //   // TXTextControl.loadDocument(TXTextControl.StreamType.WordprocessingML,
                  //   //   btoa(mystring));
                  
                      // TXTextControl.loadDocument(TXTextControl.StreamType.WordprocessingML,
                      // 'https://tsa.backvault.com.au/APP_PHP/assets/docs/1126.2.1.1/allVarsTest-CookaroundtheWorld-1126.2.1.1-260822-110114.docx');
                      let filename = 'allVarsTest-CookaroundtheWorld-1126.2.1.1-260822-110114.docx';
                      let formData_api: FormData = new FormData();
                      const URL_server_file = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + this.file_subject_number + '/';
                      // this.http.get(URL_server_file + filename, { responseType: 'blob' }).subscribe(data => {
                        // this.http.get(this.gfunc.baseUploadURL_SSL + '/TestCreateAndSaveFile.docx', { responseType: 'blob' }).subscribe(data => {
                          this.http.get(this.gfunc.baseUploadURL_SSL + '/sample.txt', { responseType: 'text' }).subscribe(data => {
                        // console.log('data2 on import...', data);
                         this.selectedFileBlob = data;
                    
                         // moved inside this subscrition
                        //  formData_api.append('files', data);
                        //  this.readDocument(selectedFileBlob);
                  
                        // file reader and new file reader goes herers.
                        // fileReader.readAsDataURL(input.target.files[0]);
                  
                  
                        // load the document beginning at the Base64 data (split at comma)
                        TXTextControl.loadDocument(TXTextControl.streamType.PlainText,  btoa(data));
                        //  TXTextControl.sendCommand(
                        //   TXTextControl.Command.EditMode,
                        //   // TXTextControl.EditMode.ReadAndSelect
                        //   // TXTextControl.EditMode.Edit
                        // );
                  
                  
                        // formData_api.append('files', this.selectedFileBlob);
                        //  ajax.send(formData_api);
                    // TXTextControl.loadDocument(TXTextControl.StreamType.WordprocessingML,
                    //   btoa(this.selectedFileBlob));
                        // console.log('FormData: ' + this.selectedFileBlob)
                      });
                  } // end loqe text file
  



// ... ERRORS.TXTCONTROL --- ::@ https://errors.textcontrol.com/

//... Txc StreamType Definitions: https://docs.textcontrol.com/textcontrol/asp-dotnet/ref.txtextcontrol.web.streamtype.enumeration.htm

// ... TXT common Load Errors - Filter Error Enumeration
//...  https://docs.textcontrol.com/textcontrol/wpf/ref.txtextcontrol.filterexception.filtererror.enumeration.htm
// .. Report of the error that supposed to be fixed in SP4 v18
// .. https://www.textcontrol.com/products/asp-dotnet/tx-text-control-dotnet-server/issues/2800/
// .. error 01-1D02 error - I keep getting when trying to import any docx document from a unix server
// ..                     - I am using Unix PHP v7.4 server, Angular V14 CLI everything works but word documents.

onClickLoad_RTF() {
  const URL_server_file = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + this.file_subject_number + '/';
      this.http.get(this.gfunc.baseUploadURL_SSL + '/sample.rtf', { responseType: 'text' }).subscribe(data => {
      this.selectedFileBlob = data;
    TXTextControl.loadDocument(TXTextControl.streamType.RichTextFormat,  btoa(data));
  });
} // end 

onClickLoad_RTF_2() {
const URL_server_file = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + this.file_subject_number + '/';
this.http.get('assets/test.rtf', { responseType: 'text' }).subscribe(data => {
    this.selectedFileBlob = data;
  TXTextControl.loadDocument(TXTextControl.streamType.RichTextFormat,  btoa(data));
});
} // end 

onClickLoad_DOCX() {
const URL_server_file = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + this.file_subject_number + '/';
    this.http.get(this.gfunc.baseUploadURL_SSL + '/sample.docx', { responseType: 'text' }).subscribe(data => {
    this.selectedFileBlob = data;
  TXTextControl.loadDocument(TXTextControl.streamType.RichTextFormat,  btoa(data));
});
} // end 

onClickLoad_DOCX_2() {
const URL_server_file = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + this.file_subject_number + '/';
    this.http.get('https://tsa.backvault.com.au/APP_PHP/assets/docs/1126.2.1.1/allVarsTest-CookaroundtheWorld-1126.2.1.1-260822-110114.docx', { responseType: 'text' }).subscribe(data => {
    this.selectedFileBlob = data;
  TXTextControl.loadDocument(TXTextControl.streamType.RichTextFormat,  btoa(data));
});
} // end 


onClickLoad_HTML() {
const URL_server_file = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + this.file_subject_number + '/';
    this.http.get(this.gfunc.baseUploadURL_SSL + '/sample.html', { responseType: 'blob' }).subscribe(data => {
    this.selectedFileBlob = data;
  TXTextControl.loadDocument(TXTextControl.streamType.HTMLFormat,  btoa(this.selectedFileBlob));
});
} // end 

onClickLoad_PDF() {
const URL_server_file = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + this.file_subject_number + '/';
    this.http.get(this.gfunc.baseUploadURL_SSL + '/sample.pdf', { responseType: 'text' }).subscribe(data => {
    this.selectedFileBlob = data;
  TXTextControl.loadDocument(TXTextControl.streamType.AdobePDF,  btoa(data));
});
} // end 


// wrong filter type?
onClickLoad_OO_DOCX() {
const URL_server_file = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + this.file_subject_number + '/';
    this.http.get(this.gfunc.baseUploadURL_SSL + '/sample_open_office.docx', { responseType: 'text' }).subscribe(data => {
    this.selectedFileBlob = data;
    // let blob_binary = TXTextControl.readAsBinaryString(data);
    TXTextControl.loadDocument(TXTextControl.streamType.WordprocessingML,  btoa(data));
    // TXTextControl.loadDocument(TXTextControl.streamType.MSOffice,  btoa(unescape(encodeURIComponent(data))));
});
} // end 



// Not Validating as a proper BLOB file... I think this is the reason word documents are not loading.
onClickLoad_TXT2() {
// const data: Blob
  const URL_server_file = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + this.file_subject_number + '/';
      this.http.get(this.gfunc.baseUploadURL_SSL + '/sample.txt', { responseType: 'blob' }).subscribe(data => {
     //file Reader API
     this.selectedFileBlob = data; //( exprimenting with API) // comment out to get correct blob format for txc load
     this.selectedFileBlob = data as Blob; //( exprimenting with API) // comment out to get correct blob format for txc load
    //  const b64 = btoa(unescape(encodeURIComponent(this.selectedFileBlob)))
    //  var str2 = decodeURIComponent(escape(atob(this.selectedFileBlob))); // reverse it them convert again below btoa
     console.log(btoa(this.selectedFileBlob));
    //  console.log(btoa('Split: ' + this.selectedFileBlob.split(",")[1]));
    //  console.log(data[0] instanceof Blob); //true
    //  TXTextControl.loadDocument(TXTextControl.streamType.PlainText,  btoa(b64)); // this returned the actural string encrypted (remove bota returns an object)
    TXTextControl.loadDocument(TXTextControl.streamType.PlainText,  btoa(this.selectedFileBlob));

  });
} // end loqe text file


// Not Validating as a proper BLOB file... I think this is the reason word documents are not loading.
onClickLoad_TXT3() {
// const data: Blob
  const URL_server_file = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + this.file_subject_number + '/';
      this.http.get(this.gfunc.baseUploadURL_SSL + '/sample.txt', { responseType: 'text' }).subscribe(data => {
     //file Reader API
     this.selectedFileBlob = data; //( exprimenting with API) // comment out to get correct blob format for txc load
    //  this.selectedFileBlob = data as Blob; //( exprimenting with API) // comment out to get correct blob format for txc load
    //  const b64 = btoa(unescape(encodeURIComponent(this.selectedFileBlob)))
    //  var str2 = decodeURIComponent(escape(atob(this.selectedFileBlob))); // reverse it them convert again below btoa
     console.log(btoa(this.selectedFileBlob));
    //  console.log(btoa('Split: ' + this.selectedFileBlob.split(",")[1]));
    //  console.log(data[0] instanceof Blob); //true
    //  TXTextControl.loadDocument(TXTextControl.streamType.PlainText,  btoa(b64)); // this returned the actural string encrypted (remove bota returns an object)
    TXTextControl.loadDocument(TXTextControl.streamType.PlainText,  btoa(this.selectedFileBlob));

  });
} // end loqe text file

// Not Validating as a proper BLOB file... I think this is the reason word documents are not loading.
onClickLoad_TXT4() {
// const data: Blob
  const URL_server_file = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + this.file_subject_number + '/';
      this.http.get(this.gfunc.baseUploadURL_SSL + '/sample.docx', { responseType: 'text' }).subscribe(data => {
     //file Reader API
     this.selectedFileBlob = data; //( exprimenting with API) // comment out to get correct blob format for txc load
    let data1 =  this.utf8_to_b64(data); // "4pyTIMOgIGxhIG1vZGU="
    let data2 =  this.b64_to_utf8('4pyTIMOgIGxhIG1vZGU='); // "✓ à la mode"

    //  this.selectedFileBlob = data as Blob; //( exprimenting with API) // comment out to get correct blob format for txc load
    //  const b64 = btoa(unescape(encodeURIComponent(this.selectedFileBlob)))
    //  var str2 = decodeURIComponent(escape(atob(this.selectedFileBlob))); // reverse it them convert again below btoa
    //  console.log(btoa('Split: ' + this.selectedFileBlob.split(",")[1]));
    //  console.log(data[0] instanceof Blob); //true
    //  TXTextControl.loadDocument(TXTextControl.streamType.PlainText,  btoa(b64)); // this returned the actural string encrypted (remove bota returns an object)
    TXTextControl.loadDocument(TXTextControl.streamType.WordprocessingML,  btoa(data1));
    //  console.log(btoa(this.selectedFileBlob));

    // Usage:
this.utf8_to_b64('✓ à la mode'); // "4pyTIMOgIGxhIG1vZGU="
this.b64_to_utf8('4pyTIMOgIGxhIG1vZGU='); // "✓ à la mode"


  });
} // end loqe text file

// Not Validating as a proper BLOB file... I think this is the reason word documents are not loading.
onClickLoad_TXT5() {
// const data: Blob
  const URL_server_file = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + this.file_subject_number + '/';
      this.http.get(this.gfunc.baseUploadURL_SSL + '/sample.docx', { responseType: 'blob' }).subscribe(data => {
     //file Reader API
     this.selectedFileBlob = data; //( exprimenting with API) // comment out to get correct blob format for txc load
     console.log(data);
    let data1 =  this.utf8_to_b64(data); // "4pyTIMOgIGxhIG1vZGU="
    let data2 =  this.b64_to_utf8(data1); // "✓ à la mode"
        console.log(data1);
        console.log(data2);
        console.log(btoa(data1));
        console.log(btoa(data2));
    TXTextControl.loadDocument(TXTextControl.streamType.PlainText,  btoa(data2));
    //  console.log(btoa(this.selectedFileBlob));

    // Usage:
this.utf8_to_b64('✓ à la mode'); // "4pyTIMOgIGxhIG1vZGU="
this.b64_to_utf8('4pyTIMOgIGxhIG1vZGU='); // "✓ à la mode"


  });
} // end loqe text file


// Not Validating as a proper BLOB file... I think this is the reason word documents are not loading.
onClickLoad_TXT6() {
// const data: Blob
  const URL_server_file = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + this.file_subject_number + '/';
      this.http.get(this.gfunc.baseUploadURL_SSL + '/sample.docx', { responseType: 'blob' }).subscribe(data => {
     //file Reader API
     this.selectedFileBlob = data; //( exprimenting with API) // comment out to get correct blob format for txc load
     console.log(data);
     console.log('Blob to string: ' + this.selectedFileBlob.blobToString);
    let data1 =  this.utf8_to_b64(data); // "4pyTIMOgIGxhIG1vZGU="
    let data2 =  this.b64_to_utf8(data1); // "✓ à la mode"
        console.log('data2: ' + data1);
        console.log('data2: ' +data2);
        console.log('data1 btoa: ' +btoa(data1));
        console.log('data2 btoa: ' + btoa(data2));
    TXTextControl.loadDocument(TXTextControl.streamType.PlainText,  btoa(this.selectedFileBlob));
    //  console.log(btoa(this.selectedFileBlob));
    // Usage:
this.utf8_to_b64('✓ à la mode'); // "4pyTIMOgIGxhIG1vZGU="
this.b64_to_utf8('4pyTIMOgIGxhIG1vZGU='); // "✓ à la mode"


  });
} // end loqe text file
// Not Validating as a proper BLOB file... I think this is the reason word documents are not loading.
onClickLoad_TXT7() {
// const data: Blob
  const URL_server_file = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + this.file_subject_number + '/';
      this.http.get(this.gfunc.baseUploadURL_SSL + '/sample.docx', { responseType: 'blob' }).subscribe(data => {
     //file Reader API
     this.selectedFileBlob = data; //( exprimenting with API) // comment out to get correct blob format for txc load
     console.log(data);
    let data1 =  this.utf8_to_b64(data); // "4pyTIMOgIGxhIG1vZGU="
    let data2 =  this.b64_to_utf8(data1); // "✓ à la mode"
        console.log(data1);
        console.log(data2);
        console.log(btoa(data1));
        console.log(btoa(data2));
    TXTextControl.loadDocument(TXTextControl.streamType.PlainText,  data2);
    //  console.log(btoa(this.selectedFileBlob));

    // Usage:
this.utf8_to_b64('✓ à la mode'); // "4pyTIMOgIGxhIG1vZGU="
this.b64_to_utf8('4pyTIMOgIGxhIG1vZGU='); // "✓ à la mode"


  });
} // end loqe text file


onClickLoad_TXT8() {
// const data: Blob
  const URL_server_file = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + this.file_subject_number + '/';
      this.http.get(this.gfunc.baseUploadURL_SSL + '/sample.docx', { responseType: 'blob' }).subscribe(data => {
     //file Reader API
     this.selectedFileBlob = data; //( exprimenting with API) // comment out to get correct blob format for txc load
     console.log(data);
    let data1 =  this.utf8_to_b64(data); // "4pyTIMOgIGxhIG1vZGU="
    // let data2 =  this.b64_to_utf8(data1); // "✓ à la mode"
    let data2 =  this.b64_to_utf8(data); // "✓ à la mode"
        console.log(data1);
        console.log(data2);
        console.log(btoa(data1));
        console.log(btoa(data2));
    TXTextControl.loadDocument(TXTextControl.streamType.PlainText,  data2);
    //  console.log(btoa(this.selectedFileBlob));

    // Usage:
this.utf8_to_b64('✓ à la mode'); // "4pyTIMOgIGxhIG1vZGU="
this.b64_to_utf8('4pyTIMOgIGxhIG1vZGU='); // "✓ à la mode"


  });
} // end loqe text file


// assets
// Not Validating as a proper BLOB file... I think this is the reason word documents are not loading.
onClickLoad_TXT9() {
// const data: Blob
  // const URL_server_file = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + this.file_subject_number + '/';
      this.http.get('assets/sample.docx', { responseType: 'blob' }).subscribe(data => {
     //file Reader API
     this.selectedFileBlob = data; //( exprimenting with API) // comment out to get correct blob format for txc load
     console.log(data);
    let data1 =  this.utf8_to_b64(data); // "4pyTIMOgIGxhIG1vZGU="
    let data2 =  this.b64_to_utf8(data1); // "✓ à la mode"
        console.log(data1);
        console.log(data2);
        console.log(btoa(data1));
        console.log(btoa(data2));
    TXTextControl.loadDocument(TXTextControl.streamType.PlainText,  btoa(data2));
    //  console.log(btoa(this.selectedFileBlob));

    // Usage:
this.utf8_to_b64('✓ à la mode'); // "4pyTIMOgIGxhIG1vZGU="
this.b64_to_utf8('4pyTIMOgIGxhIG1vZGU='); // "✓ à la mode"


  });
} // end loqe text file

// assets
// Not Validating as a proper BLOB file... I think this is the reason word documents are not loading.
onClickLoad_TXT10() {
// const data: Blob
  // const URL_server_file = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + this.file_subject_number + '/';
      this.http.get('assets/sample.docx', { responseType: 'blob' }).subscribe(data => {
     //file Reader API
     this.selectedFileBlob = data; //( exprimenting with API) // comment out to get correct blob format for txc load
     console.log(data);
    let data1 =  this.utf8_to_b64(data); // "4pyTIMOgIGxhIG1vZGU="
    let data2 =  this.b64_to_utf8(data1); // "✓ à la mode"
        console.log(data1);
        console.log(data2);
        console.log(btoa(data1));
        console.log(btoa(data2));
    TXTextControl.loadDocument(TXTextControl.streamType.PlainText,  btoa(this.selectedFileBlob.data));
    //  console.log(btoa(this.selectedFileBlob));

    // Usage:
this.utf8_to_b64('✓ à la mode'); // "4pyTIMOgIGxhIG1vZGU="
this.b64_to_utf8('4pyTIMOgIGxhIG1vZGU='); // "✓ à la mode"


  });
} // end loqe text file

// assets
// Not Validating as a proper BLOB file... I think this is the reason word documents are not loading.
onClickLoad_TXT11() {
// const data: Blob
  // const URL_server_file = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + this.file_subject_number + '/';
      this.http.get('assets/sample.docx', { responseType: 'blob' }).subscribe(data => {
     //file Reader API
     this.selectedFileBlob = data; //( exprimenting with API) // comment out to get correct blob format for txc load
     console.log(data);
    let data1 =  this.utf8_to_b64(data); // "4pyTIMOgIGxhIG1vZGU="
    let data2 =  this.b64_to_utf8(data1); // "✓ à la mode"
        console.log(data1);
        console.log(data2);
        console.log(btoa(data1));
        console.log(btoa(data2));
    TXTextControl.loadDocument(TXTextControl.streamType.WordprocessingML,  btoa(this.selectedFileBlob));
    //  console.log(btoa(this.selectedFileBlob));

//       // Usage:
// this.utf8_to_b64('✓ à la mode'); // "4pyTIMOgIGxhIG1vZGU="
// this.b64_to_utf8('4pyTIMOgIGxhIG1vZGU='); // "✓ à la mode"


  });
} // end loqe text file

onClickLoad_TXT12() {
// const data: Blob
  // const URL_server_file = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + this.file_subject_number + '/';
      this.http.get('assets/sample.docx', { responseType: 'blob' }).subscribe(data => {
     //file Reader API
     this.selectedFileBlob = data; //( exprimenting with API) // comment out to get correct blob format for txc load
     console.log(data);
    let data1 =  this.utf8_to_b64(data); // "4pyTIMOgIGxhIG1vZGU="
    let data2 =  this.b64_to_utf8(data1); // "✓ à la mode"
        console.log(data1);
        console.log(data2);
        console.log(btoa(data1));
        console.log(btoa(data2));
    TXTextControl.loadDocument(TXTextControl.streamType.MSWord,  btoa(this.selectedFileBlob));
    //  console.log(btoa(this.selectedFileBlob));

//       // Usage:
// this.utf8_to_b64('✓ à la mode'); // "4pyTIMOgIGxhIG1vZGU="
// this.b64_to_utf8('4pyTIMOgIGxhIG1vZGU='); // "✓ à la mode"


  });
} // end loqe text file




onClickLoad_TXT13() {
// const data: Blob
  // const URL_server_file = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + this.file_subject_number + '/';
      this.http.get('assets/sample.docx', { responseType: 'blob' }).subscribe(data => {
     //file Reader API
     this.selectedFileBlob = data; //( exprimenting with API) // comment out to get correct blob format for txc load
     console.log(data);
    let data1 =  this.utf8_to_b64(data); // "4pyTIMOgIGxhIG1vZGU="
    let data2 =  this.b64_to_utf8(data1); // "✓ à la mode"
        console.log(data1);
        console.log(data2);
        console.log(btoa(data1));
        console.log(btoa(data2));
    TXTextControl.loadDocument(TXTextControl.streamType.InternalFormat,  btoa(this.selectedFileBlob));
    //  console.log(btoa(this.selectedFileBlob));

//       // Usage:
// this.utf8_to_b64('✓ à la mode'); // "4pyTIMOgIGxhIG1vZGU="
// this.b64_to_utf8('4pyTIMOgIGxhIG1vZGU='); // "✓ à la mode"


  });
} // end loqe text file


onClickLoad_TXT14() {
// const data: Blob
  // const URL_server_file = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + this.file_subject_number + '/';
      this.http.get('assets/sample.docx', { responseType: 'blob' }).subscribe(data => {
     //file Reader API
     this.selectedFileBlob = data; //( exprimenting with API) // comment out to get correct blob format for txc load
     console.log(data);
    let data1 =  this.utf8_to_b64(data); // "4pyTIMOgIGxhIG1vZGU="
    let data2 =  this.b64_to_utf8(data1); // "✓ à la mode"
        console.log(data1);
        console.log(data2);
        console.log(btoa(data1));
        console.log(btoa(data2));
    TXTextControl.loadDocument(TXTextControl.streamType.InternalUnicodeFormat,  btoa(this.selectedFileBlob));
    //  console.log(btoa(this.selectedFileBlob));

//       // Usage:
// this.utf8_to_b64('✓ à la mode'); // "4pyTIMOgIGxhIG1vZGU="
// this.b64_to_utf8('4pyTIMOgIGxhIG1vZGU='); // "✓ à la mode"


  });
} // end loqe text file


onClickLoad_TXT15() {
// const data: Blob
  // const URL_server_file = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + this.file_subject_number + '/';
      this.http.get('assets/sample.docx', { responseType: 'blob' }).subscribe(data => {
     //file Reader API
     this.selectedFileBlob = data; //( exprimenting with API) // comment out to get correct blob format for txc load
     console.log(data);
    let data1 =  this.utf8_to_b64(data); // "4pyTIMOgIGxhIG1vZGU="
    let data2 =  this.b64_to_utf8(data1); // "✓ à la mode"
        console.log(data1);
        console.log(data2);
        console.log(btoa(data1));
        console.log(btoa(data2));
    TXTextControl.loadDocument(TXTextControl.streamType.PlainAnsiText,  btoa(this.selectedFileBlob));
    //  console.log(btoa(this.selectedFileBlob));

//       // Usage:
// this.utf8_to_b64('✓ à la mode'); // "4pyTIMOgIGxhIG1vZGU="
// this.b64_to_utf8('4pyTIMOgIGxhIG1vZGU='); // "✓ à la mode"


  });
} // end loqe text file


onClickLoad_TXT16() {
// const data: Blob
  // const URL_server_file = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + this.file_subject_number + '/';
      this.http.get('assets/sample.docx', { responseType: 'blob' }).subscribe(data => {
     //file Reader API
     this.selectedFileBlob = data; //( exprimenting with API) // comment out to get correct blob format for txc load
     console.log(data);
    let data1 =  this.utf8_to_b64(data); // "4pyTIMOgIGxhIG1vZGU="
    let data2 =  this.b64_to_utf8(data1); // "✓ à la mode"
        console.log(data1);
        console.log(data2);
        console.log(btoa(data1));
        console.log(btoa(data2));
    TXTextControl.loadDocument(TXTextControl.streamType.WordprocessingML,  btoa(this.selectedFileBlob));
    //  console.log(btoa(this.selectedFileBlob));

//       // Usage:
// this.utf8_to_b64('✓ à la mode'); // "4pyTIMOgIGxhIG1vZGU="
// this.b64_to_utf8('4pyTIMOgIGxhIG1vZGU='); // "✓ à la mode"


  });
} // end loqe text file


// try doing a data e on the object instead of just setting it as string variable,

TXT17() {
const URL_server_file = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + this.file_subject_number + '/';
      this.http.get('assets/sample.html', { responseType: 'blob' }).subscribe(data => {
        this.selectedFileBlob = data as Blob; //( exprimenting with API) // comment out to get correct blob format for txc load
        // this.selectedFileBlob = data;
  TXTextControl.loadDocument(TXTextControl.streamType.HTMLFormat,  btoa(this.selectedFileBlob));
});
} // end 

RTF1() {
const URL_server_file = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + this.file_subject_number + '/';
      this.http.get('assets/QCatNixEdidedOnline.rtf', { responseType: 'text' }).subscribe(data => {
        this.selectedFileBlob = data;
        console.log('Respose: ' + this.selectedFileBlob)
  TXTextControl.loadDocument(TXTextControl.streamType.RichTextFormat,  btoa(this.selectedFileBlob));
});
} // end 


RTF2() {
const URL_server_file = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + this.file_subject_number + '/';
      this.http.get('assets/renamed.rtf', { responseType: 'text' }).subscribe(data => {
        this.selectedFileBlob = data;
        console.log('Respose: ' + this.selectedFileBlob)
  TXTextControl.loadDocument(TXTextControl.streamType.RichTextFormat,  btoa(this.selectedFileBlob));
});
} // end 


// Live unedited documet - dowloaded from offce 365
RTF3() {
const URL_server_file = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + this.file_subject_number + '/';
      this.http.get('assets/Document.docx', { responseType: 'text' }).subscribe(data => {
        this.selectedFileBlob = data;
        console.log('Respose: ' + this.selectedFileBlob)
  TXTextControl.loadDocument(TXTextControl.streamType.WordprocessingML,  btoa(this.selectedFileBlob));
});
} // end 

// Saved this file as RTF on the server... as the default.... // test of actual live generated file downloaed
RTF4() {
const URL_server_file = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + this.file_subject_number + '/';
      this.http.get('assets/sample_NEW.rtf', { responseType: 'text' }).subscribe(data => {
        this.selectedFileBlob = data;
        console.log(this.selectedFileBlob)
        //UTFA charactrs
        var b64 = window.btoa(unescape(encodeURIComponent(this.selectedFileBlob)))
        console.log(b64);
        var str2 = decodeURIComponent(escape(window.atob(b64)));
        console.log(str2);
  // TXTextControl.loadDocument(TXTextControl.streamType.RichTextFormat,  btoa(this.selectedFileBlob));
  TXTextControl.loadDocument(TXTextControl.streamType.WordprocessingML,  b64);
});
} // end 


    // Usage:
    // https://developer.mozilla.org/en-US/docs/Glossary/Base64#solution_1_%E2%80%93_escaping_the_string_before_encoding_it
    // this.utf8_to_b64('✓ à la mode'); // "4pyTIMOgIGxhIG1vZGU="
    // this.b64_to_utf8('4pyTIMOgIGxhIG1vZGU='); // "✓ à la mode"
utf8_to_b64(str) {
return window.btoa(unescape(encodeURIComponent(str)));
}

b64_to_utf8(str) {
return decodeURIComponent(escape(window.atob(str)));
}



// :: Creates a new blob dynamccally and converts it to the file reader and loads it 
// :: @ https://medium.com/programmers-developers/convert-blob-to-string-in-javascript-944c15ad7d52

blobToString(){
const blb    = new Blob(["Lorem ipsum sit- Nick was here...."], {type: "text/plain"});
const reader = new FileReader();

reader.onload = (e: any) => {
var streamType = TXTextControl.streamType.PlainText;

// load the document beginning at the Base64 data (split at comma)
TXTextControl.loadDocument(streamType, e.target.result.split(",")[1]);
 TXTextControl.sendCommand(
  TXTextControl.Command.EditMode,
  // TXTextControl.EditMode.ReadAndSelect
  TXTextControl.EditMode.Edit
);
// may work strang but inveted function   
}











// addEventListener("textControlLoaded", function() {
//   //      loadDocument("<strong>Hey! It compiles! Ship it!... How Do I get this to load a default word Document instead!!!!</strong>");
//   //    });

// // This fires after the blob has been read/loaded.
// reader.addEventListener('loadend', (e) => {
//   const text = e.srcElement;
//   console.log(text);
// });

// // Start reading the blob as text.
// reader.readAsText(blb);
// }


}


/// ............ TRY!!!!!!
// .. Try Creating a new blob item from the item I get so that reader interprets
//..  https://stackoverflow.com/questions/53034797/window-url-createobjecturl-angular-7-typescript -- see CreateObjectURL.#
// .. https://developer.mozilla.org/en-US/docs/Web/API/FileReader/readAsDataURL - ReadAs DataURL - FileReader API
// .. It appears that file reader is the only method that creates the correct blob types as the filer does not validate the direct streams


// refresh the entire txc layout.
refresh_txc() {
  // TXTextControl.Refresh;
  <void> TXTextControl.refreshLayout();
  TXTextControl.removeFromDom();
}


resetContents_txc() {
  // TXTextControl.Refresh;
  TXTextControl.resetContents()
}




// this.templateDocxName
// this.gfunc.baseUploadURL_SSL + '/' + this.templateDocxName


Load_ServerFile() {
  const URL_server_file = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + this.file_subject_number + '/';
  this.http.get(this.gfunc.baseUploadURL_SSL + '/' + this.templateDocxName, { responseType: 'text' }).subscribe(data => {
      this.selectedFileBlob = data;
      console.log('Template: ' + data)
    TXTextControl.loadDocument(TXTextControl.streamType.RichTextFormat,  btoa(data));
  });
  } // end 



  // auto loads the selected template file into txc viewer
  Load_TemplateFile(filename) {
    const URL_server_file = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + this.file_subject_number + '/';
    this.http.get(this.gfunc.baseUploadURL_SSL + '/' + filename, { responseType: 'text' }).subscribe(data => {
        this.selectedFileBlob = data;
      TXTextControl.loadDocument(TXTextControl.streamType.RichTextFormat,  btoa(data));
    });
    } // end 

      // auto loads the selected template file into txc viewer
  Load_TxTemplateFile_server(filename) {
    const URL_server_file = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + this.file_subject_number + '/';
    this.http.get(this.gfunc.baseUploadURL_SSL + '/' + filename, { responseType: 'text' }).subscribe(data => {
        this.selectedFileBlob = data;
      // TXTextControl.loadDocument(TXTextControl.streamType.InternalUnicodeFormat,  btoa(data));
      TXTextControl.loadDocument(TXTextControl.streamType.InternalUnicodeFormat,  btoa((data)));
    });
    } // end 

          // auto loads the selected template file into txc viewer
  Load_TxTemplateFile(filename) {
    // const URL_server_file = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + this.file_subject_number + '/';
    // this.http.get(this.gfunc.baseUploadURL_SSL + '/' + filename, { responseType: 'text' }).subscribe(data => {
      this.http.get('assets/sample.tx', { responseType: 'text' }).subscribe(data => {
        this.selectedFileBlob = data;
      //  this.readDocument(data);

      TXTextControl.loadDocument(TXTextControl.streamType.PlainTextFormat, btoa((data)));
      // TXTextControl.loadDocument(TXTextControl.streamType.InternalUnicodeFormat,  this.utf8_to_b64(data));
    });
    } // end 




// NEW FUNCTIONS> txc and


RTF1_________________() {
  const URL_server_file = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + this.file_subject_number + '/';
        this.http.get('assets/QCatNixEdidedOnline.rtf', { responseType: 'text' }).subscribe(data => {
          this.selectedFileBlob = data;
          console.log('Respose: ' + this.selectedFileBlob)
    TXTextControl.loadDocument(TXTextControl.streamType.RichTextFormat,  btoa(this.selectedFileBlob));
  });
  } // end 




  // write a script that sends filename and does a http reqwuest to load file. (Response as text to make work.)
  LoadDocument_TEMPLATE(id, document) {
    // tslint:disable-next-line:max-line-length
    // this.http.get(this._baseUrl + 'textcontrol/loadDocument_TEMPLATE' + '?ConnectionID=' + id + '&&filename=' + document, { responseType: 'text' }).subscribe(result => {
      this.http.get(this._baseUrl + 'textcontrol/loadDocument_TEMPLATE' + '?filename=' + document + '&&ConnectionID=' + id, { responseType: 'text' }).subscribe(result => {
    // call JavaScript function from injected 'textcontrol.js'
      loadDocument_TEMPLATE(result);
      this.toastr.show('Successfully Loaded File!', {icon: '👏',})
      }, error => { console.error(error); }
    );
  }


  // write a script that sends filename and does a http reqwuest to load file. (Response as text to make work.)
 saveDocument_TEMPLATE(id, document) {
    // tslint:disable-next-line:max-line-length
// Set the values of  the model.
let DocumentName = document
let BinaryDocument = btoa(this.selectedFileBlob);

    // this.http.get(this._baseUrl + 'textcontrol/loadDocument_TEMPLATE' + '?ConnectionID=' + id + '&&filename=' + document, { responseType: 'text' }).subscribe(result => {
      this.http.get(this._baseUrl + 'textcontrol/saveTemplate' + '?DocumentName=' + document + '&&BinaryDocument=' + BinaryDocument,  { 'headers': headers }).subscribe(result => {
    // call JavaScript function from injected 'textcontrol.js'
    console.log('Document Saved');
     // loadDocument_TEMPLATE(result);
      }, error => { console.error(error); }
    );
  }




  // Test to see if loads from external server from asp first, then send to editor. -- DOES NOTE WORK@@@@!!!
  LoadDocument_TEMPLATE_Ext(document) {
    // tslint:disable-next-line:max-line-length
    // this.http.get(this.gfunc.azure_webRootPath + 'textcontrol/loadDocument_TEMPLATE_Ext' + '?ConnectionID=' + '' + '&filename=' + document, { responseType: 'text' }).subscribe(result => {
    //   // call JavaScript function from injected 'textcontrol.js'
    //   loadDocument_TEMPLATE_Ext(result);
    //   }, error => { console.error(error); }
    // );
  }






}


